<template>
  <span>
    <el-button type="primary" @click="showdialog">{{ title }}</el-button>
    <el-dialog
      title="选择使用返利"
      :visible.sync="dialogVisible"
      width="800px"
      top="0"
      append-to-body
    >
      <el-form ref="form" :inline="true" :model="searchForm">
        <el-form-item label="到期日:" prop="expireStartDate">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.expireStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">-</div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.expireEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="返利类型" prop="rebateType">
          <el-select v-model="searchForm.rebateType">
            <el-option v-for="(value,key) of typeList" :key="key" :value="key" :label="value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="()=>{rest();}">搜索</el-button>
          <el-button type="default" @click="restFormAction">重置</el-button>
        </el-form-item>

      </el-form>
      <div>
        <span v-if="yanzheng && allow > availableRebateAmount" style="display: inline-block;margin-right: 10px">
          <!-- <el-alert
            v-if="this.freight > availableRebateAmount"
            title="当前运费大于合同最大可用返利金额，请驳回该合同到渠道"
            type="error"
            :closable="false"
          /> -->
          当前合同最大可用返利金额：{{ availableRebateAmount }}元;
        </span>
        <span v-if="yanzheng && allow <= availableRebateAmount" style="display: inline-block;margin-right: 10px">
          <!-- <el-alert
            v-if="this.freight > allow"
            title="当前运费大于合同最大可用返利金额，请驳回该合同到渠道"
            type="error"
            :closable="false"
          /> -->
          当前合同最大可用返利金额：{{ allow }}元;
        </span>
        <span style="display: inline-block"> 已选返利金额：{{ totalChoose }}元</span>
      </div>
      <el-table id="rabateTable" ref="multipleTable" v-loading="tableLoading" :data="tableData"
                style="width: 100%" border :max-height="400"
                row-key="id"
                @select="selectOne"
                @select-all="selectAll"
      >
        <el-table-column
          type="selection"
          width="50"
          reserve-selection
          align="left"
          fixed="left"
        />
        <el-table-column
          label="返利编号"
          align="left"
          prop="rebateNumber"
        />
        <el-table-column
          prop="strRebateType"
          label="返利类型"
          align="left"
        />
        <el-table-column
          prop="rebateAmount"
          label="总金额"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="grantDate"
          label="发放日期"
          align="left"
        />
        <el-table-column
          prop="expireDate"
          label="到期日"
          align="left"
        />
        <el-table-column
          prop="availableAmount"
          label="可用余额"
          align="right"
          header-align="left"
        />
        <el-table-column
          label="使用金额"
          align="right"
          header-align="left"
        >
          <template v-slot="{row}">
            <el-input-number v-model="row.transferAmount" :disabled="row.isSelect" size="mini" :controls="false" style="width: 100%" />
          </template>
        </el-table-column>
        <template slot="append">
          <infinite-loading ref="infiniteLoading" force-use-infinite-wrapper="#rabateTable > .el-table__body-wrapper" :distance="10" @infinite="dosearch">
            <div slot="no-more" style="padding: 20px">加载完成</div>
            <div slot="no-results" style="padding: 20px">暂时无数据</div>
          </infinite-loading>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTransfer">确认</el-button>
      </span>
    </el-dialog>
  </span>
</template>
<script type="es6">
import { selectRebateTypeList, selectAgentAvailableRebate, getRebateSummaryAgentInfo } from '@/API';
import InfiniteLoading from 'vue-infinite-loading';
import { MathAdd } from '@/libs/util';
let inloading;
export default {
  data () {
    return {
      dialogVisible: false,
      searchForm: {
        rebateType: '',
        expireStartDate: '',
        expireEndDate: ''
      },
      tableLoading: false,
      tableData: [],
      multipleSelection: [],
      availableRebateAmount: 0,
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeList: {}
    };
  },
  props: {
    title: {
      type: String,
      default: '填选返利'
    },
    allow: {
      type: Number,
      default: 0
    },
    form: {
      type: Object,
      default: () => { return {}; }
    },
    freight: {
      type: Number,
      default: 0
    },
    yanzheng: {
      type: Boolean,
      default: true
    },
    needReload: {
      type: Boolean,
      default: false
    },
    excludeList: {
      type: Array,
      default: () => { return []; }
    }
  },
  components: {
    InfiniteLoading
  },
  computed: {
    totalChoose () {
      let count = 0;
      this.multipleSelection.forEach((item) => {
        count = MathAdd(count, item.transferAmount);
      });
      return count;
    },
    excludeIds () {
      let list = [];
      this.excludeList.forEach((item) => {
        list.push(item.rebateNumber);
      });
      return list;
    }
  },
  methods: {
    showdialog () {
      if (this.needReload) {
        this.rest();
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      }
      this.dialogVisible = true;
    },
    selectRebateTypeList () {
      selectRebateTypeList().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.typeList = json.data;
        }
      }).catch(() => {

      });
    },
    dosearch ($state) {
      inloading = $state;
      if (this.page.total <= this.tableData.length && this.tableData.length) {
        $state && $state.complete();
        return;
      }
      selectAgentAvailableRebate({
        ...this.searchForm,
        agentId: this.form.orderUnitCode,
        agentType: this.form.customerContractType,
        lists: this.excludeIds,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.page.total = json.data.total;
          if (json.data.total === 0) {
            $state && $state.complete();
          }
          this.page.currentPage++;
          json.data.list.forEach((item) => {
            item.isSelect = true;
          });
          this.tableData = this.tableData.concat(json.data.list);
          this.$nextTick(() => {
            $state && $state.loaded();
          });
        }
      }).catch(() => {

      });
    },
    rest () {
      if (inloading) {
        inloading.reset();
      }
      this.page.currentPage = 1;
      this.page.total = 0;
      this.tableData = [];
    },
    restFormAction () {
      this.searchForm.expireEndDate = '';
      this.$refs.form.resetFields();
      this.rest();
      // this.dosearch();
    },
    selectOne (selection, row) {
      if (row.isSelect) {
        row.isSelect = false;
        row.transferAmount = row.availableAmount;
      } else {
        row.isSelect = true;
        row.transferAmount = 0;
      }
      this.multipleSelection = selection;
    },
    selectAll (selection) {
      if (selection.length) {
        selection.forEach((row) => {
          row.isSelect = false;
          row.transferAmount = row.availableAmount;
        });
      } else {
        this.tableData.forEach((row) => {
          row.isSelect = true;
          row.transferAmount = 0;
        });
      }
      this.multipleSelection = selection;
    },
    confirmTransfer () {
      // 判断 订单金额 * 30% > 返利可用余额
      if (this.allow > this.availableRebateAmount) {
        // 已选返利金额 > 返利可用余额
        if (this.totalChoose > this.availableRebateAmount && this.yanzheng) {
          return (this.$notify.warning('不可超过最大可用返利金额'));
        }
      } else {
        // 已选返利金额 > 订单金额 * 30%
        if (this.totalChoose > this.allow && this.yanzheng) {
          return (this.$notify.warning('不可超过最大可用返利金额'));
        }
      }
      // if (this.totalChoose > this.availableRebateAmount) {
      //   return (this.$notify.warning('不可超过最大可用返利金额'));
      // }
      // 判断已选返利金额必须等于运费金额
      if (this.totalChoose !== this.freight) {
        return (this.$notify.warning('用返利金额必须等于运费'));
      }
      let list = [];
      this.multipleSelection.forEach((item) => {
        list.push({
          rebateNum: item.rebateNumber,
          rebateAmount: item.transferAmount,
          rebateTypeName: item.strRebateType,
          remarks: '运费'
        });
      });
      this.$emit('chooesSuccess', { list, total: this.totalChoose });
      this.dialogVisible = false;
    }
  },
  mounted () {
    this.selectRebateTypeList();
    getRebateSummaryAgentInfo({ contractNum: this.form.contractNum }).then((res) => {
      let json = res.data;
      if (json.status === '200') {
        this.availableRebateAmount = json.data.availableAmount;
      }
    }).catch(() => {

    });
  }
};
</script>
